import fetch from '~/utils/fetch';
import { REPORT_CARE_NEEDS_URL } from '~/consts/urls';

export const postCareNeedsToolRequest = data =>
  fetch(REPORT_CARE_NEEDS_URL, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });
